<app-header></app-header>
<div class="iframe">
    <!-- <iframe src="https://designer.videosity.net/" title="description"></iframe> -->
    <object data="https://bwi-audit-dev.web.app/apps/auth/login" width="100%" height="720" type="text/html">Please wait..</object>

</div>